<template>
	<div class="downId-button" @click="handleDownload">下载身份证照片</div>
</template>

<script>
import { Toast } from "@lib/gant";
import api from "@/api/downIdCard";
import { debounce } from "@/utils/debounce.js";

export default {
	name: "downIdCard",
	props: {
		accountId: Number,
	},
	data() {
		return {
			imgUrl: [],
		};
	},

	methods: {


         handleDownload: debounce(async function () {
			const params = {
				accountId: this.accountId,
				showLoading: 1,
			};
			const res = await api.downIdCard(params);
			const backUrl = res.data.imgBack;
			const frontUrl = res.data.imgFront;
			this.imgUrl = [backUrl, frontUrl];

			const downParams = {
				imagesList: this.imgUrl,
			};
			const that = this;
			window.ggj.downloadMaterial(
				Object.assign(
					{
						imagesList: [],
						showLoading: 1,

						complete(res) {
							if (res.statusCode === 1) {
								if (!that.hadDownload) {
									that.hadDownload = true;
								}
								Toast("图片已保存手机相册");
							} else {
								Toast("图片下载失败 ");
							}
						},
					},
					downParams
				)
			);
		}),
	},
};
</script>

<style lang="less" scoped>
.downId-button {
	font-size: 16px;
	font-weight: 400;
	color: #ffffff;
	line-height: 50px;
	text-align: center;
	width: 330px;
	height: 50px;
	background: #009A5C;
	border-radius: 30px;
	margin: 12px auto;
}
</style>
